export default __webpack_public_path__ + "static/media/settings-24px (1).bcc657b9.svg";